/* eslint-disable camelcase */
import { AccessPoint, Service } from './Accounts';
import { UnionServicesExIdsKeys } from './Calculate';
import { IEntrepreneur } from './UserInfo';

export type IptvPreset = ServicePreset;
export type InternetPreset = ServicePreset;
export type CtvPreset = ServicePreset;
export type UnionPreset = ServicePreset;

export interface ServicePreset {
  Access?: AccessPoint;
  AccountID: number;
  CanChangeCurrentService: boolean;
  ChangeCurrentServiceInfo: ChangeCurrentServiceInfoType;
  CountSuspendPayments: number;
  CurrentService: TypedService;
  CustomerShares: CustomerShare[];
  PreviousPayedService: Service | null;
  ServiceID: number;
  ServiceExIDs: number[] | { inet: number[]; iptv: number[]; ctv: number[] };
  Status: string;
  StatusID: number;
  Login: string | null;
  Discount: number;
  Prepaids: Prepaid[] | null;
  Services: TypedService[] | null;
  UnconnectedServices: TypedService[] | null;
  SuspendService: Service | null;
  ServicesEx: ServiceEx[] | null;
  FromDate: string;
  IsDisabled: boolean;
  DisableReason: string;
  Entrepreneur: IEntrepreneur;
  InnerAccounts?: {
    inet: InnerAccount;
    iptv?: InnerAccount;
    ctv?: InnerAccount;
  };
  Shares: AvailableShare;
}

export interface TransformServiceEx extends ServiceEx {
  key?: UnionServicesExIdsKeys;
  isConnected?: boolean;
}

export interface TransformServicePreset extends Omit<ServicePreset, 'ServiceExIDs'> {
  serviceForPayment: TypedService;
  internetLogin: string | null;
  isAvailableShare50PercentForPaidService: boolean;
  isPaidServiceSuspension: boolean;
  ServicesEx: ServiceEx[];
  ServiceExIDs: number[] | { inet: number[]; iptv: number[]; ctv: number[] };
  isBonusPrepaidsAvailable: boolean;
}

interface Prepaid {
  id: number;
  TypeID: number;
  StatusID: number;
  Balance: number;
  Amount: number;
  Discount: number;
  Bonus: number;
  FromDate: string;
  ToDate: string;
  PayDate: string;
  Comment: string;
  Service: Service;
}

export interface InnerAccount {
  id: number;
  ServiceExIDs: number[] | null;
  Status: string;
  StatusID: number;
  ServicesEx: ServiceEx[] | null;
  Access: AccessPoint;
}

export interface TypedService extends Service {
  Type?: ServiceType;
}

export interface ServiceType {
  id: number;
  Name: string;
}

export interface ServiceEx {
  AnalyticsID: null | string;
  Category: string;
  Daily: boolean;
  Description: null | string;
  FromDate: null | string;
  IsBonusPaymentAllowed: boolean;
  IsManual: boolean;
  IsOnce: boolean;
  LimitedForServices: number[];
  Monthly: boolean;
  Name: string;
  Price: number;
  Tags: { id: number; Name: string }[];
  ToDate: null | string;
  id: number;
  IsConnected: boolean;
  ExIdsKey?: UnionServicesExIdsKeys;
}

export interface ChangeCurrentServiceInfoType {
  max_count: number;
  current_count: number;
  is_available_today: boolean;
}

export interface CustomerShare {
  Action: Action;
  Image: Image;
  Name: string;
  Description: string;
  Period: Period;
  PreAction: PreAction;
  id: number;
}

interface Action {
  data: Shares;
  method: Method;
  name: string;
  type: string;
  url: string;
}

export interface Image {
  desktop: string;
  mobile: string;
  tablet: string;
}

type PreAction = Action;
type Method = 'POST';
export type ShareKeys = '35';

export interface Shares {
  shares: {
    [key in ShareKeys]: number;
  };
}

interface Period {
  from: number;
  to: number;
}

export interface CustomShareParamsActivation {
  accountType: string;
  accountId: string;
  shares: {
    [key in ShareKeys]: number;
  };
  shareDescription: string;
  image: Image;
  activationShareEnd: string;
  daysRemainBeforeShareEnd: string;
  shareName: string;
  preActionName: string;
  actionName: string;
}

export enum ShareNames {
  Connect6MonthFor50Percents = 'Connect6MonthFor50Percents',
  BonusPrepaids = 'BonusPrepaids',
}

export interface CommonShare {
  availiable_inet_services: number[];
  availiable_iptv_services: number[];
  availiable_ctv_services: number[];
  notavailiable_inet_services: number[];
  notavailiable_iptv_services: number[];
  notavailiable_ctv_services: number[];
  availiable_union_services: number[];
  notavailiable_union_services: number[];
  from_datetime: string;
  to_datetime: string;
  days: number;
  availableMonthsCount: number;
  availableDaysCount: number;
  model: {
    id: number;
    Type: string;
    Name: string;
    ShortContent: string;
    Content: string;
    Script: string;
    InfoUrl: string;
    ActionButtonUrl: string;
    StartDate: string;
    StopDate: string;
    CreateDate: string;
    CreatedBy: number;
    UpdateDate: string;
    UpdatedBy: number;
  };
}

interface AvailableShare {
  [ShareNames.Connect6MonthFor50Percents]: CommonShare;
}
